import React from 'react'

import {
  Icon,
  WalletIcon,
  ShoppingBasket,
  NotificationFilled,
  MailFilled,
  Upload,
  Discount,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import BoostSales from 'Pods/Shared/Icons/BoostSales'

function NavbarIcon({
  type,
  className = '',
  size = 'default',
}) {
  function getIcon() {
    switch (type) {
      case 'wallet':
        return WalletIcon
      case 'cart':
        return ShoppingBasket
      case 'notification':
        return NotificationFilled
      case 'message':
        return MailFilled
      case 'upload':
        return Upload
      case 'boost-credits':
        return BoostSales
      case 'discount':
        return Discount
      default:
        return null
    }
  }

  const IconComponent = getIcon()

  if (IconComponent) {
    return (
      <Icon
        color="dark"
        notSpaced
        size={size}
        svgComponent={IconComponent}
        className={className}
      />
    )
  }

  return null
}

NavbarIcon.propTypes = {
  type: string.isRequired,
  className: string,
  size: string,
}

export default NavbarIcon
